module.exports = __webpack_public_path__ + "static/Carly_Daniel2-d4e5637c5fd611feb5dfc633e91b5dbe.jpg";